import {Shell, ShellFooter} from '@hconnect/uikit/src/lib2'
import {Box, Button, CircularProgress, Typography} from '@mui/material'
import React, {Suspense} from 'react'
import {useTranslation} from 'react-i18next'

export type SimpleErrorPageProps = {
  logout?: () => void
  children: React.ReactNode
}

export const SimpleErrorPage: React.FC<SimpleErrorPageProps> = ({children, logout}) => {
  const {t} = useTranslation()

  return (
    <Suspense fallback={<CircularProgress />}>
      <Shell
        isResponsive
        footer={
          <ShellFooter label={t('footer.poweredBy')} copyrightNote={t('footer.copyrightNote')} />
        }
      >
        <Box alignItems="center" display="flex" flexDirection="column" padding={2}>
          <Typography my={2} variant="h2">
            {t('errorPage.label.error')}
          </Typography>
          <Box>{children}</Box>
          {logout && (
            <Button color="primary" onClick={logout}>
              {t('errorPage.action.logout')}
            </Button>
          )}
        </Box>
      </Shell>
    </Suspense>
  )
}
